/* 列傳選單點一章時的「圖解」：交戰雙方、前情、結果與影響（只寫正史；裴注要標出處，演義不放）
 * 鍵是列傳選單上的章節 id（分幕的章寫第一幕）。格式見 src/campaign/bg/index.ts。 */
// @ts-nocheck
export default {
  'sunjian-1': {
    sides: [
      { f: 'wu', n: '朱儁、孫堅', l: '孫堅（佐軍司馬）、鄉里少年、淮泗精兵', w: 1 },
      { f: 'hj', n: '汝潁黃巾', l: '彭脫（西華）、韓忠（宛城）' },
    ],
    before: '中平元年黃巾起事，朱儁奉命討伐汝南、潁川的黃巾，上表請孫堅擔任佐軍司馬。下邳的鄉里少年都願意跟他走，孫堅又招募商旅和淮泗精兵，合起來一千多人。孫堅乘勝深入，在西華失利，受傷墮馬躺在草中，是坐騎跑回營裡嘶鳴，將士才循著馬找到他（《吳書》）。',
    after: '汝南、潁川的黃巾退守宛城，孫堅獨當一面，先登城頭，眾人跟著攀上，大破黃巾。朱儁把經過上報朝廷，孫堅拜別部司馬。',
    src: '《三國志·吳書·孫堅傳》及注引《吳書》；《後漢書·朱儁傳》〈皇甫嵩傳〉',
  },
  'sunwu-3': {
    sides: [
      { f: 'wu', n: '孫堅', l: '孫堅、祖茂（數十騎）' },
      { f: 'dz', n: '董卓', l: '徐榮', w: 1 },
    ],
    before: '關東諸侯起兵討伐董卓，孫堅也從長沙北上，到魯陽和袁術會合，袁術表他為破虜將軍、領豫州刺史。孫堅移屯梁東時，被董卓的大軍猛攻。',
    after: '孫堅只帶著幾十騎突圍。他把常戴的紅頭巾交給祖茂，追兵爭著追祖茂，孫堅從小路脫身；祖茂把頭巾掛在墳間燒過的柱子上、伏在草裡，追兵圍了好幾圈才發現是柱子，散去。',
    src: '《三國志·吳書·孫堅傳》；《後漢書·董卓傳》',
  },
  'sunwu-4': {
    sides: [
      { f: 'wu', n: '孫堅', l: '孫堅', w: 1 },
      { f: 'dz', n: '董卓', l: '胡軫（大督護）、呂布（騎督）、華雄（都督）' },
    ],
    before: '梁東一敗，孫堅的部眾四散，他重新收攏兵馬，進到陽人。董卓派胡軫、呂布帶兵來攻；兩人不和，呂布等人謊稱城裡的敵人已經跑了，誘全軍連夜趕路，到了人馬疲憊（《英雄記》）。',
    after: '孫堅在陽人大破卓軍，斬了都督華雄。他隨後進軍洛陽，董卓西遷長安；後來孫堅攻打劉表，單騎走在峴山時被黃祖的軍士射殺。',
    src: '《三國志·吳書·孫堅傳》及注引《英雄記》',
  },
  'sunwu-5': {
    sides: [
      { f: 'wu', n: '孫策', l: '孫策、程普、黃蓋（父親舊部）', w: 1 },
      { f: 'han', n: '劉繇（揚州刺史）', l: '牛渚營守軍' },
    ],
    before: '孫堅死後，孫策依附袁術。舅舅吳景等人在江邊和劉繇的部將樊能、張英打了一年多都打不下，孫策向袁術請求帶兵去幫忙，被表為折衝校尉。他出發時只有一千多兵、幾十匹馬，走到歷陽已經聚了五六千人。',
    after: '孫策渡江之後轉戰各地，所向皆破，沒人擋得住；他攻下劉繇的牛渚營，把邸閣裡的糧穀、戰具全部拿下（《江表傳》，興平二年）。孫策軍令嚴整，不擾百姓，江東人心歸附。',
    src: '《三國志·吳書·孫策傳》及注引《江表傳》',
  },
  'sunwu-6': {
    sides: [
      { f: 'wu', n: '孫策', l: '孫策與從騎十三（韓當、宋謙、黃蓋等）' },
      { f: 'han', n: '劉繇', l: '太史慈（只帶一騎）' },
    ],
    before: '太史慈是東萊人，渡江投奔同郡的劉繇。有人勸劉繇用他當大將，劉繇怕被人笑，只派他去偵察敵情。太史慈只帶一名騎兵出去，在神亭撞上帶著十三騎的孫策。',
    after: '太史慈直接上前和孫策打。孫策刺中他的馬，奪下他背上的手戟，太史慈也搶到孫策的頭盔；兩邊的兵馬同時趕到，於是各自散去。之後劉繇兵敗逃往豫章，太史慈逃進山裡自稱丹楊太守。',
    src: '《三國志·吳書·太史慈傳》',
  },
  'sunwu-7': {
    sides: [
      { f: 'wu', n: '孫策', l: '太史慈', w: 1 },
      { f: 'han', n: '劉繇殘部', l: '劉繇死後無所歸附的士眾萬餘人' },
    ],
    before: '孫策擒住太史慈，親手替他解開繩子，問他神亭那時如果抓到我會怎樣，太史慈答「未可量也」。後來劉繇死在豫章，部眾一萬多人沒有歸屬，孫策派太史慈去安撫。身邊的人都說他一定往北走、不會回來；孫策說子義捨我，還能投誰？在昌門送他時問何時回來，太史慈答「不過六十日」。',
    after: '太史慈果然如期回來。孫策後來分出海昏、建昌左右六縣，讓他當建昌都尉，督諸將抵擋劉表的姪子劉磐，劉磐從此不再來犯。',
    src: '《三國志·吳書·太史慈傳》',
  },
  'sunwu-8': {
    sides: [
      { f: 'wu', n: '孫權', l: '周泰、左右護衛（不到一千人）', w: 1 },
      { f: 'hj', n: '山賊', l: '山賊數千人' },
    ],
    before: '周泰原本跟著孫策當左右，孫權喜歡他的為人，向孫策要來跟在身邊。孫策出兵討伐六縣山賊時，孫權住在宣城，護衛不到一千人，又大意沒有築圍籬，山賊幾千人突然殺到。',
    after: '孫權剛上馬，賊的刀刃已經砍到身邊，連馬鞍都被砍中；只有周泰奮身護住孫權，左右因此才敢迎戰。賊散之後，周泰身上十二處傷，昏了很久才醒。孫策很感激他，任他為春穀長。',
    src: '《三國志·吳書·周泰傳》',
  },
  'sunwu-9': {
    sides: [
      { f: 'wu', n: '孫策', l: '孫策（單騎）' },
      { f: 'han', n: '許貢門客', l: '前吳郡太守許貢的小兒子與門客' },
    ],
    before: '孫策先前殺了吳郡太守許貢，許貢的小兒子和門客逃到江邊躲起來。建安五年，曹操和袁紹在官渡相持，孫策暗中打算襲擊許都、迎接漢帝，正在整軍。他出門時常單騎先行，隨從跟不上。',
    after: '孫策單騎出行，突然撞上許貢的門客，被刺成重傷。臨終把孫權託付給張昭，對孫權說上陣爭天下你不如我、任用賢能保住江東我不如你，當夜去世，年僅二十六歲。十九歲的孫權接掌江東。',
    src: '《三國志·吳書·孫策傳》〈吳主傳〉',
  },
  'sunwu-10': {
    sides: [
      { f: 'wu', n: '孫權', l: '董襲、凌統（敢死各百人）、呂蒙（破前鋒）', w: 1 },
      { f: 'lbiao', n: '黃祖（江夏太守）', l: '黃祖、陳就（水軍）' },
    ],
    before: '孫堅當年就是死在黃祖的軍士手下，孫權繼位後幾次西征黃祖。原本是黃祖部下的甘寧投奔孫權，建議先取黃祖、再圖巴蜀。建安十三年孫權再征江夏，黃祖用兩艘蒙衝橫鎖沔口，船上千人用弩交射，吳軍過不去。',
    after: '董襲、凌統各帶一百名敢死士突入，董襲親手砍斷兩條大纜，蒙衝順水漂開，大軍跟著攻進去，攻下城池。黃祖隻身逃走，被騎士馮則追上斬首，吳軍俘虜男女數萬人。',
    src: '《三國志·吳書·董襲傳》〈吳主傳〉〈甘寧傳〉〈呂蒙傳〉',
  },
  'sunwu-11': {
    sides: [
      { f: 'wu', n: '主戰', l: '周瑜、魯肅（諸葛亮代劉備來聯合）', w: 1 },
      { f: 'wu', n: '主降', l: '張昭等「議者」' },
      { f: 'wei', n: '曹操', l: '號稱水軍八十萬' },
    ],
    before: '曹操南下，劉琮舉荊州投降，曹軍順江東下，寫信給孫權說要「會獵於吳」。孫權召集群臣商議，大家都說不如迎降，領頭的是孫策託孤的張昭。孫權起身更衣，魯肅追到廊下說：「將軍迎操，欲安所歸？」勸他召回在鄱陽的周瑜。',
    after: '周瑜當眾駁斥議者，說曹操名為漢相、實為漢賊，又數出曹軍的種種不利；諸葛亮也說曹軍遠來疲憊，是強弩之末。孫權拔刀砍斷面前的奏案，說再有人說迎曹就和這張案一樣（《江表傳》），隨即派周瑜、程普率三萬人和劉備並力。',
    src: '《三國志·吳書·周瑜傳》〈魯肅傳〉〈張昭傳〉；〈蜀書·諸葛亮傳〉；〈周瑜傳〉注引《江表傳》',
  },
  'sunwu-12': {
    sides: [
      { f: 'wu', n: '孫權、劉備聯軍', l: '周瑜、程普、黃蓋（火船）', w: 1 },
      { f: 'wei', n: '曹操', l: '曹軍水寨' },
    ],
    before: '孫劉聯軍和曹軍在赤壁相遇，曹軍已經有疾病流行，第一次交戰就失利，退到江北。黃蓋看出曹軍船艦首尾相接，可以用火燒。於是拿蒙衝鬥艦幾十艘裝滿柴草、灌上油，蓋上帷幕、插上牙旗，先寫信給曹操假稱要投降，每艘大船後面都繫著逃生用的走舸。',
    after: '曹軍官兵都伸長脖子觀望，指著說黃蓋來降了。離曹軍二里多時同時點火（《江表傳》），風勢猛烈，火一路燒到岸上的營落。黃蓋被流矢射中、落入寒冷的江水，被吳兵撈起卻沒人認得，他勉強喊了一聲韓當，韓當認出他的聲音，替他換衣才保住性命（《吳書》）。',
    src: '《三國志·吳書·周瑜傳》及注引《江表傳》；〈黃蓋傳〉注引《吳書》',
  },
  'sunwu-14': {
    sides: [
      { f: 'wu', n: '孫權、劉備聯軍', l: '周瑜、程普、黃蓋', w: 1 },
      { f: 'wei', n: '曹操', l: '曹操（烏林）' },
    ],
    before: '火船衝進曹軍的船陣，大火藉著風勢燒上北岸的烏林。一時之間濃煙烈焰滿天，被燒死、淹死的人馬非常多。',
    after: '周瑜等人帶著輕銳緊跟在火後面，擂鼓大進，曹軍大潰（《江表傳》）。曹操又遇上疾疫，官兵死了很多，只好率軍北還，留曹仁守江陵；周瑜隨後進攻南郡，一年多後曹仁棄城退走。',
    src: '《三國志·吳書·周瑜傳》及注引《江表傳》；〈魏書·武帝紀〉',
  },
  'sunwu-15': {
    sides: [
      { f: 'wei', n: '曹操', l: '張遼（八百敢死士）、李典、樂進', w: 1 },
      { f: 'wu', n: '孫權', l: '孫權、凌統（親近三百人）、谷利' },
    ],
    before: '建安二十年，曹操西征張魯，只留張遼、李典、樂進帶七千多人守合肥。孫權率十萬大軍圍城。張遼趁吳軍還沒站穩，連夜招募八百名敢死之士，天一亮就披甲持戟衝進吳營，殺到孫權的帥旗下；孫權大驚，退到高冢上用長戟自守。',
    after: '孫權圍城十幾天攻不下，只好撤軍，在逍遙津北被張遼突襲。凌統帶三百親兵衝入重圍保護孫權，左右全部戰死，自己也受傷；津橋南段已經拆掉，谷利在馬後揮鞭，孫權的馬一躍而過（《江表傳》）。張遼因功拜征東將軍。',
    src: '《三國志·魏書·張遼傳》；〈吳書·凌統傳〉〈吳主傳〉注引《江表傳》',
  },
  'sunwu-16': {
    sides: [
      { f: 'wu', n: '孫權', l: '甘寧（前部督，健兒百餘人）', w: 1 },
      { f: 'wei', n: '曹操', l: '曹軍前營' },
    ],
    before: '呂蒙勸孫權在濡須水口築塢防守。曹操出兵濡須，號稱步騎四十萬，臨江飲馬；孫權率七萬人迎戰，派甘寧領三千人當前部督（《江表傳》）。孫權特別賜給甘寧米酒菜餚，命他去砍曹軍的前營，甘寧分給手下一百多人吃。',
    after: '甘寧帶一百多名健兒直奔曹營，拔掉鹿角翻牆入營，斬了幾十個首級；曹軍驚慌擂鼓、火把多得像星星，甘寧已經回營奏樂高呼萬歲。孫權說「孟德有張遼，孤有興霸，足相敵也」（以上《江表傳》），給甘寧加兵二千人。',
    src: '《三國志·吳書·甘寧傳》及注引《江表傳》；〈呂蒙傳〉',
  },
  'sunwu-17': {
    sides: [
      { f: 'wu', n: '孫權', l: '呂蒙（白衣搖櫓的精兵）', w: 1 },
      { f: 'shu', n: '關羽', l: '江邊屯候；麋芳（守江陵）、士仁（守公安）' },
    ],
    before: '關羽北攻樊城，留兵守江陵、公安，沿江設屯候防備東吳。呂蒙假稱生病回建業，由陸遜接替，關羽因此放心，把守兵陸續調往樊城。後來關羽擅取孫權的湘關米，孫權便派呂蒙偷襲。',
    after: '呂蒙把精兵藏在船艙裡，讓士兵穿白衣扮成商人搖櫓，日夜趕路，把關羽沿江的屯候全部抓起來，關羽完全不知道。守公安的士仁、守江陵的麋芳相繼投降，呂蒙入城後嚴禁擾民；關羽的部眾軍心瓦解，他退到麥城，西逃途中在臨沮被擒斬。',
    src: '《三國志·吳書·呂蒙傳》〈吳主傳〉；〈蜀書·關羽傳〉',
  },
  'sunwu-18': {
    sides: [
      { f: 'wu', n: '孫權', l: '陸遜（大都督）、朱然、潘璋、韓當、徐盛、孫桓', w: 1 },
      { f: 'shu', n: '劉備', l: '劉備（從巫峽到夷陵連營數十屯）' },
    ],
    before: '關羽死後，劉備稱帝，親率大軍東下伐吳。孫權任陸遜為大都督，帶朱然、潘璋等五萬人抵擋。劉備從巫峽、建平一路紮營到夷陵邊界，立了幾十座營。諸將都想出戰，陸遜認為不可，堅守了七八個月，等蜀軍兵疲意沮。',
    after: '陸遜下令每人拿一把茅草，用火攻打，一旦得手就全軍同時進攻，一口氣攻破四十多座營。劉備連夜逃走，只勉強退進白帝城，船隻、器械和水陸軍資幾乎全部丟光；第二年劉備死在永安。',
    src: '《三國志·吳書·陸遜傳》；〈蜀書·先主傳〉',
  },
};
